export default "/images/vendor/flag-icon-css/flags/4x3/ma.svg?363a4f79da72a6e74be0d7f8d4e6c1dc";